import { t } from "i18next"
import { useUnit } from "effector-react"
import cn from "clsx"
import { Label, Radio, Typography } from "@callcenter/design-system"

import { userAccountModel } from "../../models"
import { AGENT_WORKSPACE_LAYOUT_OPTIONS } from "./agent-workspace-layout-settings.constants"

import styles from "./agent-workspace-layout-settings.module.pcss"

export const AgentWorkspaceLayoutSettings = () => {
  const actions = useUnit({
    handleChange: userAccountModel.handleChange
  })

  const formValue = useUnit(userAccountModel.$formValue)
  const isSubmitPending = useUnit(userAccountModel.$isSubmitPending)

  return (
    <div>
      <Label label={t("userProfile_userProfileSidePanel_interfaceSettingsLabel_agentWorkspaceDisplayLayoutLabel")} />
      <div className={styles.cards}>
        {AGENT_WORKSPACE_LAYOUT_OPTIONS.map(({ value, title, description, illustration }) => {
          const isSelected = formValue.agent_workspace_display_layout === value

          return (
            <button
              key={value}
              type="button"
              tabIndex={0}
              disabled={isSubmitPending}
              className={cn(styles.card, { [styles.selected]: isSelected })}
              onClick={() => actions.handleChange({ name: "agent_workspace_display_layout", value })}
            >
              <Radio name="agent_workspace_display_layout" isSelected={isSelected} isDisabled={isSubmitPending}>
                {title}
              </Radio>
              <div className={styles.preview}>
                <img src={illustration} alt="" className={styles.illustration} />
                <Typography.Body2 className={styles.description}>{description}</Typography.Body2>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
